import { createWizardRoute } from '@lemonade-hq/chat-wizard-web-client';
import { LemonadeApp } from '@lemonade-hq/nuiza';
import type React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  analyticsConfig,
  authConfig,
  errorConfig,
  infraConfig,
  layoutConfig,
  localeConfig,
  monitoringConfig,
  navConfig,
  securityConfig,
  userConfig,
} from '../config';
import { Error } from '../errors';
import { getPolicyParam } from '../utils/helpers';
import { Brand } from './brand/Brand';
import { Revolut } from './brand/Revolut';
import { Quote } from './quote/Quote';

const queryClient = new QueryClient();

export const App: React.FC = () => (
  <LemonadeApp
    analytics={analyticsConfig()}
    auth={authConfig()}
    error={errorConfig().hasError}
    infra={infraConfig()}
    layout={layoutConfig()}
    locale={localeConfig()}
    monitoring={monitoringConfig()}
    nav={navConfig()}
    security={securityConfig()}
    user={userConfig()}
  >
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {createWizardRoute({
            analytics: { analyticsProduct: 'home-edge-onboarding' },
            browserNavigation: { clientBasePath: `/home-check/${getPolicyParam()}` },
            chatEnginePersistence: {
              forceRestart: true,
              scriptName: 'home-check-flow',
              serverBaseUrl: window.location.origin,
              initData: { policyId: getPolicyParam() },
            },
            presentation: { initialAvatar: 'maya', showRestart: false },
          })}
          <Route element={<Quote />} path="/quotes/:quoteId" />

          <Route element={<Brand />} path="/uk/brand" />
          <Route element={<Brand />} path="/fr/brand" />
          <Route element={<Brand />} path="/fr/en/brand" />

          <Route element={<Revolut />} path="/revolut" />
          <Route element={<Error />} path="/unauthorized" />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  </LemonadeApp>
);
